/**
 * Seasonal filtering constants
 */

export interface Season {
  id: string;
  name: string;
  emoji: string;
  description: string;
  months: number[]; // Month numbers (0-11 for JavaScript Date months)
  bestFor: string[];
}

export const SEASONS: Season[] = [
  {
    id: 'spring',
    name: 'Spring',
    emoji: '🌸',
    description: 'Perfect for wildlife migration and blooming nature',
    months: [2, 3, 4], // March, April, May
    bestFor: ['Bird migration', 'Wildflower blooms', 'Mild weather', 'Baby animals']
  },
  {
    id: 'summer',
    name: 'Summer',
    emoji: '☀️',
    description: 'Best for outdoor adventures and active wildlife',
    months: [5, 6, 7], // June, July, August
    bestFor: ['Hiking', 'Water activities', 'Long daylight', 'Marine life']
  },
  {
    id: 'autumn',
    name: 'Autumn',
    emoji: '🍂',
    description: 'Ideal for fall foliage and animal preparation for winter',
    months: [8, 9, 10], // September, October, November
    bestFor: ['Fall colors', 'Harvest season', 'Cooler weather', 'Animal foraging']
  },
  {
    id: 'winter',
    name: 'Winter',
    emoji: '❄️',
    description: 'Great for unique winter wildlife and snow activities',
    months: [11, 0, 1], // December, January, February
    bestFor: ['Snow activities', 'Winter wildlife', 'Cozy experiences', 'Northern lights']
  }
];

/**
 * Get the current season based on the current month
 */
export function getCurrentSeason(): Season {
  const currentMonth = new Date().getMonth();
  return SEASONS.find(season => season.months.includes(currentMonth)) || SEASONS[0];
}

/**
 * Get season by ID
 */
export function getSeasonById(id: string): Season | undefined {
  return SEASONS.find(season => season.id === id);
} 